module.exports = __webpack_public_path__ + "img/fogg-fatal-error-2.b60808f9.svg";